import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Funciona en pieles de más de 50 años?',
  a: 'Absolutamente. A esa edad la renovación celular es más lenta, y este protocolo está diseñado precisamente para acelerarla usando Tretinoína, el estándar de oro antienvejecimiento.'
}, {
  q: '¿Tengo que comprar productos caros después de leerlo?',
  a: 'Todo lo contrario. El libro te enseña a comprar en la farmacia genérica. Gastarás menos de lo que gastas hoy, garantizado.'
}, {
  q: '¿Es seguro si tengo rosácea o sensibilidad?',
  a: "Sí. Incluimos variaciones del ciclo para pieles 'extra-sensibles' que priorizan la recuperación antes que la exfoliación."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 px-6 bg-white" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <div className="text-center mb-10 md:mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-52">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-sage mx-auto" data-id="element-53"></div>
        </div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="border border-charcoal/10 rounded-xl overflow-hidden bg-cream" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-56">
                <span className="font-bold text-lg pr-4" data-id="element-57">{faq.q}</span>
                <ChevronDown className={`w-6 h-6 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>
              <AnimatePresence data-id="element-59">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-60">
                    <div className="p-6 pt-0 text-charcoal/70 leading-relaxed border-t border-charcoal/5" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}